// @flow

export default function getPreviewRawData(
  location: ?(Location & { state?: ?Object }),
): ?string {
  return (location && location.state && location.state.previewData) || null;
}
